<template>
    <div>
        <div>
            <Row style="padding-bottom: 10px;">
                <Col span="4" style="padding-right: 10px;">
                <Button type="primary" long @click="onClickSearch">检索</Button>
                </Col>
            </Row>
            <Table ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns" stripe border></Table>
            <Row style="padding:10px 0px 0px 0px">
                <Col span=15>
                <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
                    @on-page-size-change="changePageSize" style="text-align:left"></Page>
                </Col>
            </Row>
        </div>
        
        <!-- 模态框search -->
        <Modal v-model="isShowModalSearch" :mask-closable="false" width="380">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="md-create" />
                <span>按照输入的字段检索</span>
            </p>
            <Form ref="searchParam" :label-width="100" :model="searchParam">
                <FormItem prop="addresslowestleveladdressid" label="地址：">
                    <Cascader :data="addressData" change-on-select filterable transfer @on-change="chooseAddress"></Cascader>
                </FormItem>
                <FormItem prop="personnelName" label="安装人员：">
                    <Input v-model="searchParam.personnelName" clearable placeholder="请输入安装人员..."></Input>
                </FormItem>
                <FormItem prop="workOrderStatus" label="安装状态：">
                    <Select v-model="searchParam.workOrderStatus" clearable placeholder="请选择安装状态...">
                        <Option v-for="(value, key) in orderStatus" :key="key" :value="key" :label="value" />
                    </Select>
                </FormItem>
                <FormItem prop="workOrderCompleteDatestampMin" label="最早完成时间：">
                    <DatePicker :editable="false" v-model="searchParam.workOrderCompleteDatestampMin" type="datetime" placeholder="请输入最早完成时间..." style="width: 248px"></DatePicker>
                </FormItem>
                <FormItem prop="workOrderCompleteDatestampMax" label="最晚完成时间：">
                    <DatePicker :editable="false" v-model="searchParam.workOrderCompleteDatestampMax" type="datetime" placeholder="请输入最晚完成时间..." style="width: 248px"></DatePicker>
                </FormItem>
                <FormItem prop="fixHistoryMeterId" label="设备表号：">
                    <Input v-model="searchParam.fixHistoryMeterId" clearable placeholder="请输入设备表号..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" size="large" long @click="commitSearch">检索</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            let thisOrderStatus = this.orderStatus;
            this.showColumns = [
                {
                    title: "地址",
                    key: "addresslowestleveladdressids",
                    width: 300
                },
                {
                    title: "安装人员",
                    key: "personnelName"
                },
                {
                    title: "安装状态",
                    key: "workOrderStatus",
                    render: function(h,params){
                        return h('div',thisOrderStatus[this.row.workOrderStatus]);
                    }
                },
                {
                    title: "创建时间",
                    key: "workOrderInsertDatestamp",
                    width: 170,
                    render: function(h,params){
                        return h('div',global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.row.workOrderInsertDatestamp)));
                    }
                },
                {
                    title: "完成时间",
                    key: "workOrderCompleteDatestamp",
                    width: 170,
                    render: function(h,params){
                        return h('div',global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.row.workOrderCompleteDatestamp)));
                    }
                },
                {
                    title: "设备表号",
                    key: "fixHistoryMeterId"
                }
            ];
            this.showPage();
        },
        data() {
            const validateyyyy = (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error('请输入yyyy...'));
                } else {
                    callback();
                }
            };
            return {
                orderStatus: {
                    0:"创建未分配",
                    10:"创建已分配",
                    20:"已完成"
                },
                addressData: [],
                typeName: "",
                urlClass: "viewWorkOrder",
                height: window.innerHeight,
                isLoadingButton: false,
                isShowInsertModal: false,
                isShowUpdateModal: false,
                isShowDeleteModal: false,
                isShowModalSearch: false,
                isShowTarget: false,
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [],
                selectedData: null,
                formInsert: {
                },
                formUpdate: {
                },
                ruleInsert: {
                    xxxx: [{
                        required: true,
                        message: '请输入xxxx...',
                        trigger: 'blur'
                    }],
                    yyyy: [{
                        required: true,
                        validator: validateyyyy,
                        trigger: 'change'
                    }]
                },
                searchParam: {
                }
            }
        },
        methods: {
            showPage() {
                let that = this;
                that.searchParam.workOrderType = '安装';
                that.$parent.$parent.$parent.spinShow(true);
                $.ajax({
                    url: "/api/" + that.urlClass + "/selectPage?page=" +
                        that.currentPage +
                        "&pageAmount=" +
                        that.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.searchParam),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showData = data.body.resultList;
                        that.dataCount = data.body.amount;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(){
                        that.isSpinShow = false;
                        that.$parent.$parent.$parent.spinShow(false);
                    }
                });
            },
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            },
            onClickSearch() {
                this.isShowModalSearch = true;
            },
            commitSearch() {
                console.log(this.searchParam);
                this.isShowModalSearch = false;
                this.showPage();
            },
            chooseAddress(param) {
                console.log(param);
                if (param.length > 0) {
                    this.searchParam.addresslowestleveladdressid = param[param.length - 1] * 1; //当复选框选中时则会打印出选中的内容
                } else {
                    this.searchParam.addresslowestleveladdressid = null;
                }
            }
        }
    }
</script>

<style>
</style>
